import { t } from "@lingui/macro";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@reactive-resume/ui";

export const RejectDialog = ({
  open,
  onOpenChange,
  onReject,
  isDeleting,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onReject: () => void;
  isDeleting: boolean;
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{t`Reject Optimization`}</AlertDialogTitle>
        <AlertDialogDescription>
          {t`Are you sure you want to reject this optimization? This will delete the optimized version of your resume and cannot be undone.`}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t`Cancel`}</AlertDialogCancel>
        <AlertDialogAction variant="error" onClick={onReject} disabled={isDeleting}>
          {isDeleting ? t`Rejecting...` : t`Reject`}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
